


























































































import { Component, Vue, Provide } from "vue-property-decorator";
import { pagnition } from "@/utils/commonConfig";
import { timeFormat } from "@/utils/index";

@Component({
  name: "CombinationProperty"
})
export default class CombinationProperty extends Vue {
  @Provide() private resultData: any = [];
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private pagnition: any = pagnition;
  @Provide() private isGetTicketListActionDone: boolean = false;
  private created() {
    this.getTicketList();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getTicketList();
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getTicketList();
  }
  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getTicketList();
    }
  }
  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getTicketList();
  }

  // 查询
  private async getTicketList() {
    const { getRepaymentDetail }: any = await import(
      "@/request/getRepaymentDetail"
    );
    let arg = {
      // pageIndex: this.pageIndex,
      // pageSize: this.pageSize,
      ticketitemid: Number(this.$route.query.ticketitemid), 
      date: this.$route.query.date,
      adminuid: Number(this.$route.query.adminuid),
    };
    let res = await getRepaymentDetail(arg, this);
    this.isGetTicketListActionDone = res ? res.loading : false;
    if (res) {
      let _result =
        typeof res.listList == "object"
          ? res.listList
          : JSON.parse(res.listList);
      if (_result) {
        let data:any = [];
        // _result = [{amount: {isRootInsert: false,repayprincipal: 999,repayvirtual: 0,unpaidprincipal: 427},orderid: "201201830200001926",detailList: [{amountpayed: 1,ctime: 1608711383955,repaytype: 0},{amountpayed: 2,ctime: 1608711383955,repaytype: 2},{amountpayed: 3,ctime: 1608711383955,repaytype: 3},{amountpayed: 4,ctime: 1608711383955,repaytype: 4}]}];
        _result.map((item:any)=>{
          let unspecified:any = null; // 其他入账
          let repay:any = null; // 用户还款
          let roll:any = null; // 展期入账
          let coupon:any = null; // 优惠券入账
          let reduce:any = null; // 减免入账
          item.detailList.map((i:any)=>{
            let item = {
              amountpayed: i.amountpayed,
              ctime: timeFormat(i.ctime)
            }
            if(Number(i.repaytype) === 0){
              unspecified = item
            } else if(Number(i.repaytype) === 1){
              repay = item
            } else if(Number(i.repaytype) === 2){
              roll = item
            } else if(Number(i.repaytype) === 3){
              coupon = item
            } else if(Number(i.repaytype) === 4){
              reduce = item
            }   
          });
          let dataItem = {
            orderid: item.orderid,
            amount : Number(item.amount.repayprincipal) + Number(item.amount.repayvirtual) + Number(item.amount.unpaidprincipal),
            unspecified: unspecified,
            repay: repay,
            roll: roll,
            coupon: coupon,
            reduce: reduce
          }
          data.push(dataItem)
        })
        this.resultData = data;
      }
      if (res.pageout || res.total) {
        this.pagerCount = res.total ? res.total : res.pageout.total;
      }
    }
  }
}
